// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader{position:relative;width:4.5rem;height:4.5rem;display:flex;justify-content:center;align-items:center}.loader__text{position:relative;font-family:LaPrairie;color:#fff;font-weight:400;font-size:1rem;z-index:1}.loader__background{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.3);border-radius:50%}.loader__border{position:absolute;width:102%;height:102%;top:-1%;left:-1%;stroke-width:2;fill:none}", ""]);
// Exports
module.exports = exports;
